import { usePathAndData } from "../../../hook/usePathAndData";
import { AppLayout } from "../../layout/AppLayout";
import { Calendario } from "../../view/Calendario/Calendario";
import { ListaCalendario } from "../../view/Calendario/ListaCalendario";

export const PageCalendario = () => {
    const { path } = usePathAndData(); // Usa el hook

    return (
        <AppLayout>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div className="card">
                            <div className="card-body" style={{ borderRadius: "13px" }}>
                                {path[1] === "calendario" && path[2] === "lista" && <ListaCalendario />}
                                {path[1] === "calendario" && path[2] === "ver" && <Calendario />}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AppLayout>
    );
};
